import { InferRequestType, InferResponseType } from "hono/client";
import { client } from "../client";

export const ACTIVITIES_QUERY_KEY = ["activities"];
export const RECENT_CLUB_ACTIVITIES_QUERY_KEY = ["recentClubActivities"];

type ActivityPostRequest = InferRequestType<typeof client.activities.$post>;
export type SportType = ActivityPostRequest["json"]["type"];
export type Activity = InferResponseType<typeof client.activities.$get, 200>[0];
export type EmojiReaction = Activity["emojiReactions"][0];
export type Emoji = EmojiReaction["emoji"];

export type UploadActivityRequest = InferRequestType<
  typeof client.activities.$post
>["json"];

export type UploadActivityResponse = InferResponseType<
  typeof client.activities.$post,
  201
>;

export type ClaimActivityRequest = InferRequestType<
  typeof client.activities.claim.$post
>["json"];

export type ClaimActivityResponse = InferResponseType<
  typeof client.activities.claim.$post,
  200
>;

export type ReactToActivityRequest = InferRequestType<
  typeof client.activities.react.$post
>["json"];
export type ReactToActivityResponse = InferResponseType<
  typeof client.activities.react.$post,
  200
>;
